import { render } from "./TuningForkIcon.vue?vue&type=template&id=5c8ba445"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__